import React from 'react'

import { useT } from '../../i18n'
import {
  capacityAssignmentFor,
  readCapacityTables,
  readDefaultCapacityTable,
  type LotCapacityAssignment
} from '../../utils/carryingCapacity'

// Capacidad de carga (findings #151): which table a new lot / arrival uses.
// '' = the facility default. Hidden while the facility has no table.

type FarmLike = { metadata?: Record<string, unknown> | null } | null | undefined

export type CapacityTablePickerProps = {
  farm: FarmLike
  value: string
  onChange: (value: string) => void
  disabled?: boolean
  testId?: string
}

/** The copy to store for a picker value, or null when the facility has no table. */
export const capacityAssignmentForChoice = (farm: FarmLike, value: string, now = new Date().toISOString()): LotCapacityAssignment | null => {
  const tables = readCapacityTables(farm)
  const table = (value ? tables.find((candidate) => candidate.id === value) : null) ?? readDefaultCapacityTable(farm)
  return table ? capacityAssignmentFor(table, now) : null
}

export default function CapacityTablePicker({ farm, value, onChange, disabled, testId = 'capacity-table-picker' }: CapacityTablePickerProps) {
  const t = useT()
  const tables = readCapacityTables(farm)
  if (tables.length === 0) return null
  const defaultTable = readDefaultCapacityTable(farm)
  return (
    <label style={{ display: 'flex', flexDirection: 'column', fontWeight: 600, gap: 4, fontSize: 14 }}>
      {t('capacity.picker.label')}
      <select
        data-testid={testId}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        disabled={disabled}
        style={{ padding: 10, borderRadius: 8, border: '1px solid #cbd5f5', fontSize: 14 }}
      >
        {defaultTable ? <option value="">{t('capacity.picker.default', { name: defaultTable.name })}</option> : <option value="">{t('capacity.picker.none')}</option>}
        {tables.filter((table) => table.id !== defaultTable?.id).map((table) => (
          <option key={table.id} value={table.id}>{table.name}</option>
        ))}
      </select>
      <span style={{ fontSize: 12, color: '#6b7280', fontWeight: 400 }}>{t('capacity.picker.help')}</span>
    </label>
  )
}
